import { render, staticRenderFns } from "./FormOptionGroup.vue?vue&type=template&id=400d5648&scoped=true"
import script from "./FormOptionGroup.vue?vue&type=script&lang=js"
export * from "./FormOptionGroup.vue?vue&type=script&lang=js"
import style0 from "./FormOptionGroup.vue?vue&type=style&index=0&id=400d5648&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d5648",
  null
  
)

export default component.exports